import { create } from 'zustand';

const getInitialTheme = () => {
  try {
    return localStorage.getItem('valoriza_theme') || 'light';
  } catch {
    return 'light';
  }
};

export const useThemeStore = create((set) => ({
  theme: getInitialTheme(),
  toggleTheme: () =>
    set((state) => {
      const next = state.theme === 'light' ? 'dark' : 'light';
      try { localStorage.setItem('valoriza_theme', next); } catch {}
      return { theme: next };
    }),
}));
